import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RegExpService {

  private readonly ALL_LETTERS: string = 'a-zA-Z';
  private readonly POLISH_ALPHABET_LETTERS: string = 'ĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż';
  private readonly ALL_AND_POLISH_LETTERS = `${this.ALL_LETTERS}${this.POLISH_ALPHABET_LETTERS};`
  private config: RegExpConfig[] = [
    {
      key: RegExpKey.REGISTRATION_NUMBER,
      regExp: `^[A-PR-Z][A-PR-Z0-9]{3,7}$`
    },
    {
      key: RegExpKey.POSTAL_CODE,
      regExp: '[0-9]{2}-[0-9]{3}'
    },
    {
      key: RegExpKey.VIN,
      regExp: '[A-HJ-NPR-Z\\d]{13}[\\d]{4}'
    },
    {
      key: RegExpKey.PHONE_NUMBER,
      regExp: '^([1-9][0-9])+([1-4][0-7]|4[9]|[5-9][0-9])[0-9]{7}$'
    },
    {
      key: RegExpKey.CITY,
      regExp: `[${this.ALL_AND_POLISH_LETTERS}]+[ ._-]*[${this.ALL_AND_POLISH_LETTERS}]+[ ._-]*[${this.ALL_AND_POLISH_LETTERS}]+`
    },
    {
      key: RegExpKey.STREET,
      regExp: `[${this.ALL_AND_POLISH_LETTERS}0-9 \'.,_-]*[${this.ALL_AND_POLISH_LETTERS}]+[${this.ALL_AND_POLISH_LETTERS}0-9 \'.,_-]*`
    },
    {
      key: RegExpKey.BUILDING_NUMBER,
      regExp: `^[\\d+AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż ._\\-\\/]*$`
    },
    {
      key: RegExpKey.FLAT_NUMBER,
      regExp: `^[0-9$AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż ._\\-\\/]*$`
    },
    {
      key: RegExpKey.COUNTY,
      regExp: `^[${this.ALL_LETTERS}ąćęłńóżźśĆĘŁŃÓŻŹ]+$`
    },
    {
      key: RegExpKey.FIRST_NAME,
      regExp: `^[${this.ALL_LETTERS}àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšśžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŚŽ∂ð,.\'-]+$`
    },
    {
      key: RegExpKey.LAST_NAME,
      regExp: `^[${this.ALL_LETTERS}àáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšśžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŚŽ∂ð ,.\'-]+$`
    },
    {
      key: RegExpKey.PARTNER_NAME,
      regExp: '^[a-zA-Z0-9]{1,32}$'
    }
  ];

  constructor() { }

  getRegExp(key: RegExpKey): string {
    const regExpConfig = this.config.find(item => item.key === key);
    return regExpConfig ? regExpConfig.regExp : null;
  }
}

interface RegExpConfig {
  key: RegExpKey;
  regExp: string;
}

export enum RegExpKey {
  REGISTRATION_NUMBER = 'REGISTRATION_NUMBER',
  POSTAL_CODE = 'POSTAL_CODE',
  VIN = 'VIN',
  PHONE_NUMBER = 'PHONE_NUMBER',
  CITY = 'CITY',
  STREET = 'STREET',
  BUILDING_NUMBER = 'BUILDING_NUMBER',
  FLAT_NUMBER = 'FLAT_NUMBER',
  COUNTY = 'COUNTY',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  PARTNER_NAME = 'PARTNER_NAME',
}
